(function() {
    'use strict';

    angular
        .module('jotApp')
        .controller('TabObjectTypesMappingController', TabObjectTypesMappingController);

    TabObjectTypesMappingController.$inject = ['$scope', '$state', '$rootScope', 'entity', 'TabObjectTypes', 'pagingParams', 'AlertService'];

    function TabObjectTypesMappingController($scope, $state, $rootScope, entity, TabObjectTypes, pagingParams, AlertService) {

        var vm = this;

        vm.tabObjectTypes = [];
        vm.templateMetric = [];
        vm.espandMetric = {};
        vm.templateMetricString = [];

        vm.charToSearch = pagingParams.search;

        vm.isValid = false;
        vm.errorJson = "";

        vm.updateJsonObject = function() {
            try {
                JSON.parse(vm.script);
            } catch (e) {
                vm.isValid = false;
                vm.errorJson = "Invalid JSON Format";
            }
            vm.message = JSON.parse(vm.script);
            if(Object.keys(vm.message)[0].toString() === "properties"){
                vm.isValid = true;
            } else {
                vm.isValid = false;
                vm.errorJson = "First key must be properties";
            }
        };

        if(entity.$promise) {
            entity.$promise.then(function () {
                vm.tabObjectTypes = entity;
                var body = {id: vm.tabObjectTypes.id};

                TabObjectTypes.getTemplate(body, onSuccess, onError);

                function onSuccess(data) {
                    var obj = data.properties;
                    angular.forEach(obj, function (value, key) {
                        var template = {};
                        template.name=key;
                        if(value.type != undefined){
                            template.type = value.type;
                            template.visibility = true;
                        } else {
                            template.type = "object";
                            template.visibility = true;
                            template.folderClass = "fa-plus-square";
                            template.addMetric = "fa-pencil";
                            var level = 0;
                            template.subProperties = [];
                            angular.forEach(value.properties, function (value, key) {
                                template.subProperties.push(getProperties(value,key, level));
                            })
                        }
                        vm.templateMetric.push(template);
                    });
                    for(var i = 0; i < Object.keys(vm.templateMetric).length; i++){
                        vm.templateMetricString.push(JSON.stringify(vm.templateMetric[i]));
                    }
                }

                function getProperties(value, key, level) {
                    var subTemplate = {};
                    level++;
                    subTemplate.name = key;
                    if(value.type != undefined){
                        subTemplate.type = value.type;
                        subTemplate.level = (level*20)+6;
                        subTemplate.level = subTemplate.level.toString() + "px";
                    } else {
                        subTemplate.type = "object";
                        subTemplate.folderClass = "fa-plus-square";
                        subTemplate.addMetric = "fa-pencil";
                        subTemplate.level = (level*20)+6;
                        subTemplate.level = subTemplate.level.toString() + "px";
                        subTemplate.subProperties = [];
                        angular.forEach(value.properties, function (value, key) {
                            subTemplate.subProperties.push(getProperties(value,key, level));
                        })
                    }
                    return subTemplate;
                }

                function onError() {
                    AlertService.error("Template not Available");
                }
            });
        }

        vm.search = function(){
            searchIn();
        };

        function searchIn() {
            for(var i = 0; i < vm.templateMetricString.length; i++){
                if(vm.templateMetricString[i].includes(vm.searchText)){
                    vm.templateMetric[i].visibility = true;
                } else {
                    vm.templateMetric[i].visibility = false;
                }
            }
        }

        var onSaveSuccess = function (result) {
            $scope.$emit('jotApp:tabObjectTypesUpdate', result);
            vm.isSaving = false;
            $state.reload();
        };

        var onSaveError = function () {
            vm.isSaving = false;
        };

        vm.save = function () {
            var body = {
                id: vm.tabObjectTypes.id,
                index: "jot_"+vm.tabObjectTypes.objectTypeName.toLowerCase()+"_template",
                properties: vm.message
            };
            TabObjectTypes.putTemplate(body, onSaveSuccess, onSaveError);
        };

        vm.clear = function () {
            vm.script = "";
            vm.isValid = false;
            vm.errorJson = "";
        };

        vm.updateNewObject = function () {
            deleteProperties(vm.templateMetric);
            var obj = getObject(vm.templateMetric);
            var mapping = JSON.stringify(obj);
            var body = {
                id: vm.tabObjectTypes.id,
                index: "jot_"+vm.tabObjectTypes.objectTypeName.toLowerCase()+"_template",
                mapping: mapping
            };
            TabObjectTypes.newInObject(body, onSuccessObjectMap, onErrorObjectMap);

            function onSuccessObjectMap() {
                $state.reload();
            }

            function onErrorObjectMap() {}
        };

        function getObject(array) {
            var obj = {};
            array.forEach(function (a) {
                if(a.type != "object"){
                    obj[a.name] = {type: a.type};
                } else {
                    obj[a.name] = getObject(a.subProperties);
                }
            });
            return {properties: obj};
        }

        function deleteProperties (metrics) {
            metrics.forEach(function (a) {
                delete a.level;
                delete a.visibility;
                delete a.folderClass;
                delete a.addMetric;
                if(a.subProperties != undefined){
                    deleteProperties(a.subProperties);
                }
            })
        }
    }
})();
